import { jwtDecode } from 'jwt-decode';
import { store } from '../redux/store';

export const isTokenExpired = () => {
  return isTokenExpiredWithCustomDate(Date.now());
};

export const isTokenExpiredWithCustomDate = (date: number) => {
  const token = store.getState().accessToken.value;

  // Guard: return true (expired) if token is null or empty
  if (!token || typeof token !== 'string' || token.trim() === '') {
    return true;
  }

  try {
    const decodeToken = jwtDecode(token);

    if (!decodeToken || !decodeToken.exp) return true;

    // decodeToken.exp expressed in seconds, convert to miliseconds.
    const expTime = (decodeToken?.exp as number) * 1000;
    return expTime < date;
  } catch (_error) {
    // If token is malformed, treat as expired
    return true;
  }
};
